import { mutator } from 'satcheljs';
import { discardSmimeOptions } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator that resets the SmimeOptionsStore values.
 */
export default mutator(discardSmimeOptions, actionMessage => {
    const smimeOptionsStore = store();
    smimeOptionsStore.isSmimeSign = null;
    smimeOptionsStore.isSmimeEncrypt = null;
    smimeOptionsStore.isManuallyPickCertificate = null;
    smimeOptionsStore.signingCertificateSubject = null;
    smimeOptionsStore.signingCertificateId = null;
});
